import React, { useState } from "react";
import { FOKUSTYP_META, FOKUSTYP_DISPLAY_ORDER } from "@/components/FokustypGlyphs";

const Chip = ({ label, typ, testId }) => (
  <span data-testid={testId} className="inline-flex items-center gap-1 rounded-full border border-slate-200 bg-slate-50 px-2 py-0.5 text-xs text-slate-600">
    {label}: <strong className="text-slate-900">{typ ? FOKUSTYP_META[typ].name : "unklar"}</strong>
  </span>
);

export const EntscheidungKarte = ({ item, onSave }) => {
  const [typ, setTyp] = useState(item.typ || null);
  const [begr, setBegr] = useState(item.begruendung || "");
  const [busy, setBusy] = useState(false);
  const save = async (verwerfen = false) => {
    setBusy(true);
    try { await onSave(item.id, { typ: verwerfen ? null : typ, begruendung: begr, verwerfen }); } finally { setBusy(false); }
  };
  return (
    <article data-testid={`entscheidung-${item.id}`} className="rounded-xl bg-white border border-slate-200 p-4 space-y-3">
      <p className="text-sm text-slate-900 leading-relaxed">„{item.text}“</p>
      <div className="flex flex-wrap gap-1.5">
        <Chip label="KI-Vorschlag" typ={item.ki_vorschlag} testId={`entscheidung-${item.id}-ki`} />
        <Chip label="Heuristik" typ={item.heuristik_typ} testId={`entscheidung-${item.id}-heuristik`} />
        <Chip label="Pro-Ergebnis" typ={item.pro_typ} testId={`entscheidung-${item.id}-pro`} />
        {item.kontext && <span className="text-xs text-slate-400 self-center">{item.kontext}</span>}
      </div>
      <div className="flex flex-wrap gap-2">
        {FOKUSTYP_DISPLAY_ORDER.map((t) => (
          <button key={t} type="button" onClick={() => setTyp(t)} data-testid={`entscheidung-${item.id}-typ-${t}`}
            className={`rounded-full px-3 py-1 text-sm font-bold border transition-colors ${typ === t ? "bg-[#4563BB] text-white border-[#4563BB]" : "bg-white text-slate-700 border-slate-300 hover:border-[#4563BB]"}`}>
            {FOKUSTYP_META[t].name}
          </button>
        ))}
      </div>
      <input value={begr} onChange={(e) => setBegr(e.target.value)} maxLength={500} data-testid={`entscheidung-${item.id}-begruendung`}
        placeholder="Kurze Begründung (optional), z. B. „Bewertungsangst, nicht Widerstand“"
        className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm" />
      <div className="flex gap-2">
        <button type="button" disabled={!typ || busy} onClick={() => save(false)} data-testid={`entscheidung-${item.id}-speichern`}
          className="rounded-md bg-[#F3651D] px-4 py-2 text-sm font-bold text-white disabled:opacity-40">Entscheidung speichern</button>
        <button type="button" disabled={busy} onClick={() => save(true)} data-testid={`entscheidung-${item.id}-verwerfen`}
          className="rounded-md border border-slate-300 px-4 py-2 text-sm text-slate-600">Fall verwerfen</button>
      </div>
    </article>
  );
};
